import { useQuery } from "react-query";
import { getEmployeeReportsToCount } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetEmployeeReportsCount = (officeCode) => {
  return useQuery(
    ["EmployeeReportsToCount", officeCode],
    () => getEmployeeReportsToCount(officeCode),
    { refetchOnWindowFocus: false }
  );
};
